<template>
    <div>
        <a href="#" @click.prevent="print()" class="text-grey-400 hover:text-green-500 text-3xl" title="Skriv ut denne siden">
            <font-awesome-icon icon="print" content="Skriv ut denne siden" v-tippy="{ placement : 'bottom' }" />
            <span class="sr-only">
                Skriv ut denne siden
            </span>
        </a>
        <a :href="shareFacebookUrl" target="_blank" class="text-grey-400 hover:text-green-500 text-3xl" title="Del på Facebook">
            <font-awesome-icon :icon="[ 'fab', 'facebook-square' ]" content="Del på Facebook" v-tippy="{ placement : 'bottom' }" />
            <span class="sr-only">
                Del denne siden på Facebook (åpnes i nytt vindu)
            </span>
        </a>
    </div>
</template>

<script>
export default {
    computed: {
        shareFacebookUrl() {
            return 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.origin + window.location.pathname;
        }
    },
    methods: {
        print() {
            window.print();
        }
    }
};
</script>
